const INVITATION_CODE_LENGTH = 8;
const INVITATION_SUBMIT_LIMIT = 3;
const OTP_RESEND_DELAY = 2; // in minutes
const AGE_LIMIT = '18';
export { INVITATION_CODE_LENGTH, INVITATION_SUBMIT_LIMIT, OTP_RESEND_DELAY, AGE_LIMIT };